const loadmore = {
  mounted(el, binding) {
    let selector
    // 支持传入特定 class
    if (binding.arg) {
      selector = document.querySelector(`.${binding.arg} .el-select-dropdown__wrap`)
    } else {
      selector = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap')
    }
    let awaitPromise = null
    if (!selector) return
    selector.addEventListener('scroll', function () {
      const scrollPosition = this.scrollHeight - Math.ceil(this.scrollTop) <= this.clientHeight
      if (scrollPosition && this.scrollTop !== 0 && !awaitPromise) {
        // 接收一个promise
        awaitPromise = binding.value(selector)
        awaitPromise
          .then(() => {
            awaitPromise = null
          })
          .catch(() => {
            awaitPromise = null
          })
      }
    })
  }
}

export { loadmore }
